module.exports = __webpack_public_path__ + "img/25.2db1bd06.jpg";